export enum FirebaseErrorCode {
    EXPIRED_ACTION_CODE = 'auth/expired-action-code',
    INVALID_ACTION_CODE = 'auth/invalid-action-code',
    WRONG_PASSWORD = 'auth/wrong-password',
    INTERNAL_ERROR = 'auth/internal-error',
    USER_NOT_FOUND = 'auth/user-not-found',
    TOO_MANY_REQUESTS = 'auth/too-many-requests',
    NETWORK_REQUEST_FAILED = 'auth/network-request-failed'
}
